
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import { mapState, mapMutations } from "vuex";
import { coinList } from "../service/getdata";
export default {
components: {
Toast,XHeader
},
data() {
return {
sort: 1,
coinList: [],
msg: "",
show: false,
timerInfo:null
};
},
computed: {
...mapState(["token"]),
},
created() {
this.getCoinList(true);





},
methods: {
getCoinList(isLoading) {
if (isLoading) {
this.coinList = [];
this.$Loading();
}

var that = this;

coinList({ token: this.token, type: this.sort }).then(
function (res) {
var res = res.data;
if (isLoading) {
that.$Loading.close();
}
if (res.status == "1") {
that.coinList = res.data;
} else if (res.status == "-1") {
that.$router.push("/pages/relogin");
}
}.bind(this),
function () {
if (isLoading) {
that.$Loading.close();
}
console.log("error");
}
);

},
clearTimer() {

clearInterval(this.timerInfo);
this.timerInfo = null;
},
},
deactivated() {
this.clearTimer();
},
beforeDestroy() {
this.clearTimer();
},
};



// WEBPACK FOOTER //
// ./src/pages/qihuolist.vue